// Home.js
import "./Home.css";
import apiRequest from "../../apiCall";
import React, { useState, useEffect } from "react";

import Advertise from "./Advertise";
import HomeAbout from "./Home-aboutus";
import Howtouse from "./Howtouse";
import Digitalads from "./Digitalads";
import Influencer from "./influencer";
import Testimonial from "./Testimonial";

import line1 from "../../Assets/Icons/line1.png";
import elipse from "../../Assets/Icons/elipse.svg";
import ElipseHeading from "../../Assets/Icons/elipse-heading.png";
import leafleft from "../../Assets/Icons/leafleft.png";

import { useDispatch } from "react-redux";
import { setLoading } from "../../Redux/action";

export default function Home() {
  const [homeData, setHomeData] = useState(null);
  const dispatch = useDispatch();

  useEffect(() => {
    const fetchData = async () => {
      try {
        dispatch(setLoading(true));
        const res = await apiRequest("GET", "home", null, false, false);
        setHomeData(res);
        dispatch(setLoading(false));
      } catch (error) {
        console.error("Error fetching data:", error);
        dispatch(setLoading(false));
      }
    };

    fetchData();
  }, [dispatch]);

  const advertiseData = homeData && homeData.Advertise;
  const section2Data = homeData && homeData.Section2;
  const howToUseZeroZeroData = homeData && homeData.HowToUseZerozero;
  const digitalAdsData = homeData && homeData.DigitalAds;
  const influencerCollabData = homeData && homeData.InfluencerCollab;
  const testimonialData = homeData && homeData.Testimonial;

  const AboutImages = { elipse, line1 };
  const CollabarationImages = { leafleft, ElipseHeading };

  return (
    <>
      {homeData ? (
        <div className="home">
          {/* Render components with guarded data */}
          <Advertise advertise={advertiseData} />
          <HomeAbout homeAboutData={section2Data} aboutimages={AboutImages} />
          <Howtouse howtouseimages={ElipseHeading} howToUseZerozero={howToUseZeroZeroData} />
          <Digitalads videolink={digitalAdsData} digitaladsimages={ElipseHeading} />
          <Influencer influencerCollab={influencerCollabData} collabaration={CollabarationImages} />
          <Testimonial testimonialimage={ElipseHeading} testimonialdata={testimonialData} />
          {/* <Blog />
       <InstaGallary />
       <Available /> */}
        </div>
      ) : null}
    </>
  );
}
